import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren, ReactNode } from 'react';

import { LoginLayoutHeader, LoginLayoutTemplate, TLoginLayoutMessage } from '@gem/components';
import { getMascotImageSrc } from '@gem/utils';

import Entities from 'STORE';

interface IUnauthorizedLayoutTemplateProps {
  className?: string;
  title?: string;
  header?: string | ReactNode;
  subtitle?: string | ReactNode;
  message?: TLoginLayoutMessage | null;
  isLoading?: boolean;
  info?: string | ReactNode;
  onBack?(): void;
  isShowLogo?: boolean;
}

export const UnauthorizedLayoutTemplate: FC<PropsWithChildren<IUnauthorizedLayoutTemplateProps>> =
  observer((props) => {
    const {
      title,
      subtitle,
      message,
      onBack,
      children,
      className,
      isLoading,
      info,
      isShowLogo,
      header,
    } = props;
    const { mainLogoLight, mainLogoDark } = PROJECT_CONFIG.imageAssets;

    return (
      <LoginLayoutTemplate
        header={header ?? <LoginLayoutHeader>{title}</LoginLayoutHeader>}
        subtitle={subtitle}
        message={message}
        onBack={onBack}
        className={className}
        isDarkMode={Entities.appearance.isDark}
        isLoading={isLoading}
        logoSrc={{
          light: getMascotImageSrc(mainLogoLight),
          dark: getMascotImageSrc(mainLogoDark),
        }}
        info={info}
        isShowLogo={isShowLogo}
      >
        {children}
      </LoginLayoutTemplate>
    );
  });
